import TenancyShowcasingsReport from "./TenancyShowcasingsReport";

export default TenancyShowcasingsReport;